export enum Feature {
  ZWINGER_DECKAKT_WELPEN_FORMULAR = 'zwinger-deckakt-welpen-formular',
  ZWINGER_DECKAKT_DETAILS = 'zwinger-deckakt-details',
  MELDUNG_FORMULAR = 'meldung-formular',
  MELDEPORTAL_TEILNEHMER_LIST = 'meldeportal-teilnehmer-list',
  MELDEPORTAL_TEILNEHMER_EDIT = 'meldeportal-teilnehmer-edit',
  MELDEPORTAL_MEINE_MELDUNGEN_LIST = 'meldeportal-meine-meldungen-list',
  MELDEPORTAL_TEILNEHMER_READONLY = 'meldeportal-teilnehmer-readonly',
  MELDEPORTAL_TEILNEHMER_STATS = 'meldeportal-teilnehmer-stats',
  NOTIFICATION_BOX = 'notification-box',
  MELDEPORTAL_GEMELDETE_TEILNEHMER_LIST = 'meldeportal-gemeldete-teilnehmer-list',
  USER_ADDRESS_UPDATE_REMINDER = 'user-address-update-reminder',
  CONFIGURATION_LOADER = 'configuration-loader',
  DECKSCHEIN = 'deckschein-registration',
}
